import { useQuery } from '@tanstack/react-query'

import queries from '@/api/queries'
import statusResources from '@/api/status'

export const useObject = () =>
  useQuery(queries.status(), statusResources.get, {
    staleTime: Infinity,
  }).data?.object
